import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ComingSoon - Página de Próximamente
 * 
 * Página amigable que se muestra para funcionalidades que están en desarrollo
 */
const ComingSoon = ({ 
    title = "Próximamente", 
    description = "Estamos trabajando en esta funcionalidad. Pronto estará disponible.",
    feature = "esta función"
}) => {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
            <div className="max-w-2xl w-full text-center">
                {/* Icono animado */}
                <div className="mb-8 inline-block">
                    <div className="relative">
                        <div className="absolute inset-0 bg-primary-500/20 rounded-full blur-2xl animate-pulse"></div>
                        <div className="relative bg-gradient-to-br from-primary-400 to-primary-600 rounded-full p-8 shadow-2xl">
                            <svg 
                                className="w-20 h-20 text-white" 
                                fill="none" 
                                viewBox="0 0 24 24" 
                                stroke="currentColor"
                            >
                                <path 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                    strokeWidth={2} 
                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                                />
                            </svg>
                        </div>
                    </div>
                </div>

                {/* Título */}
                <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-4">
                    {title}
                </h1>

                {/* Badge */}
                <div className="inline-block mb-6">
                    <span className="bg-slate-900 text-white px-4 py-2 rounded-full text-sm font-black uppercase tracking-widest">
                        🚀 PRÓXIMAMENTE
                    </span>
                </div>

                {/* Descripción */}
                <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto leading-relaxed">
                    {description}
                </p>

                {/* Mensaje adicional */}
                <div className="bg-gradient-to-r from-primary-50 to-blue-50 border border-primary-200 rounded-2xl p-6 mb-8 max-w-lg mx-auto">
                    <p className="text-gray-700 font-medium">
                        💡 Mientras tanto, puedes explorar nuestros eventos y organizar tus propios pozos de pádel.
                    </p>
                </div>

                {/* Botones de acción */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    <Link
                        to="/"
                        className="bg-primary-500 hover:bg-primary-600 text-white font-bold py-4 px-8 rounded-xl text-lg shadow-lg shadow-primary-500/30 transition-all transform hover:-translate-y-0.5 active:scale-95 w-full sm:w-auto"
                    >
                        ← Volver al inicio
                    </Link>
                    
                    <Link
                        to="/events"
                        className="bg-white hover:bg-gray-50 text-gray-700 font-semibold py-4 px-8 rounded-xl text-lg border-2 border-gray-200 transition-all transform hover:-translate-y-0.5 active:scale-95 w-full sm:w-auto"
                    >
                        Ver eventos
                    </Link>
                </div>

                {/* Decoración */}
                <div className="mt-12 flex justify-center gap-2">
                    <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
                    <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                    <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
